import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/familyGy/banner.jpg'
import navColor from '../../assets/familyGy/nav/color.png'
import navBg from '../../assets/familyGy/nav/nav_bg.png'

import far1 from '../../assets/familyGy/nav/far1.png'
import far1_active from '../../assets/familyGy/nav/far1_active.png'
import far2 from '../../assets/familyGy/nav/far2.png'
import far2_active from '../../assets/familyGy/nav/far2_active.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(104.6),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(181.5),
    backgroundImage: `url(${navBg})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${calcRemFn(100)} ${calcRemFn(82)} 0`
  },
  topBtnBaseCss: {
    width: calcRemFn(100.6),
    height: calcRemFn(40.6),
  },

}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    }
  ]
}

const pictureList = [
  {
    key: '1_1',
    picNum: 6,
    pid: 105621
  },
  {
    key: '2_1',
    picNum: 7,
    pid: 105621
  }
]
function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/familyGy/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'blue',
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

pictures.unshift({
  son: [
    require('../../assets/familyGy/ctn/1_0_1.jpg')
  ],
})


const topDiff = {
  firstSon: '_i1',
  top1_i1: 20,
  top2_i1: 35,
}

export default {
  title: '盖娅传说联名款',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
}
